<template>
  <b-container id="maindiv">

    <section>
      <b-row id="content">
        <div class="col-md-12">
          <h2>{{$lang('lunch')}}</h2>
          <p class="my-3">{{$lang('description')}}</p>
        </div>
      </b-row>
    </section>

    <section id="mainsection">
      <div id="content" class="d-flex flex-wrap justify-content-around">

        <div v-if="wait" class="text-center text-muted my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>          

        <div class="oneweek mb-3" v-for="oneweek in lunchweeks" v-bind:key="oneweek.id">
          <h6>{{oneweek.caption}}</h6>
          <div class="oneday" v-for="oneday in oneweek.days" v-bind:key="oneday.caption" v-bind:style="{'border-color': dayColors[oneday.dayofweek]}">
            <p class="text-muted">{{oneday.dd}}</p>
            {{oneday.choice}}
          </div>
          <p>{{oneweek.availablecaption}}</p>
          <button class="btn btn-primary" @click="editLunchOrder(oneweek.weekid, oneweek.caption)" v-if="oneweek.available">{{oneweek.buttoncaption}}</button>
        </div>

      </div>
    </section>

    <b-modal v-bind:busy="form.wait || form.loadwait" no-close-on-backdrop id="modal-2" size="xl" :title="$lang('editLunchOrder')" @ok.prevent="handleOk" :ok-title="$lang('ok')" :cancel-title="$lang('cancel')">
      <LunchOrderItem :item="form" :colors="dayColors"></LunchOrderItem>
    </b-modal>

    <b-alert v-if="error" class="mt-5 text-center" show variant="warning">{{error}}</b-alert>

  </b-container>
</template>

<script>
import axios from 'axios';
import LunchOrderItem from "./LunchOrderItem.vue";
export default {
  created() {
    this.wait = true;
    this.fetchList()
  },
  data() {
    return {
      form: {
        wait: null, 
        error: null,
        loadwait: null,
        weekid: 0,
        weekcaption: null,
        days: [],
      },
      lunchweeks: [],
      dayColors: {
        1: "#6699aa",
        2: "#aa6666",
        3: "#88ff88",
        4: "#993399",
        5: "#ff99aa",
        6: "#ddffff",
        7: "#ddffaa",
      },
      wait: true,
      error: null,
    };
  },
  methods: {
    fetchList(){
       this.error = null;
       axios.get("/api/GetLunchList")
         .then(resp => {
           if (!resp.data.cardid){
              this.error = this.$lang("nocard")
           } else {
              this.lunchweeks = resp.data.weeks;
           }
           this.wait = null;
         })
         .catch(err => {
           if (err.response.status == 401)
              this.$router.push('/')
         })         
    }, 
    editLunchOrder(weekid, weekcaption){
      this.form.wait = null;
      this.form.error = null;
      this.form.loadwait = true;
      this.form.weekid = weekid;
      this.form.weekcaption = weekcaption;
      axios.get("/api/GetLunch?id="+weekid)
      .then(resp => {
        this.form.days = resp.data; 
        this.form.loadwait = null;
      })
      .catch(err => {
           if (err.response.status == 401)
              this.$router.push('/');
      })
      this.$bvModal.show("modal-2");
    },
    handleOk(evt) {
      this.form.wait = true;
      this.form.error = null;
      var data2save = {
        weekid: this.form.weekid,
        days: this.form.days.map((i) => {
          return {dayn:i.dayn, choice:i.choice};
        }),
      }
      axios.post('/api/SaveLunch', data2save) 
        .then(resp => {
           this.$bvModal.hide("modal-2");
           this.fetchList();
           this.$bvToast.toast(resp.data.message, {title: "Success", variant: "success"});  
        })    
        .catch(error => {
          this.form.wait = null;
          this.form.error = error.message;
          if (error.response.data.message) {
             this.form.error = error.response.data.message;
          }
        });

    },
  },
  components: {
    LunchOrderItem
  },
  locales: {
    en: {
        lunch: "Lunch Orders",
        ok: "Save Changes",
        cancel: "Cancel",
        editLunchOrder: "Edit Lunch Order",
        description: "To place an lunch order, please select a week and choose the desired dishes by day of the week",
        nocard: "No lunch cards found. Unable to order.",
    },
    de: {
        lunch: "Mittagessen Bestellungen",
        ok: "Änderungen speichern",
        cancel: "Abbrechen",
        editLunchOrder: "Mittagessen Bestellung",
        description: "Um eine Mittagessen Bestellung aufzugeben, wählen Sie eine Woche aus und geben Sie die gewünschten Gerichte nach Wochentag an.",
        nocard: "Keine Mittagessenkarten gefunden. Kann nicht bestellen.",        
    },
    ru: {
        lunch: "Заказы обедов",
        ok: "Сохранить изменения",
        cancel: "Отмена",
        editLunchOrder: "Редактирование заказа",
        description: "Для оформления заказа выберите неделю и укажите желаемые блюда по дням недели.",
        nocard: "Для размещения заказа требуется привязка карты заказа обедов к аккаунту.",
    },
    pl: {
        lunch: "Zamówienia na lunch",
        ok: "Zapisz zmiany",
        cancel: "Anulować",
        editLunchOrder: "Edycja zamówienia",
        description: "Aby złożyć zamówienie należy wybrać tydzień i wskazać żądane dania według dnia tygodnia.",
        nocard: "Aby złożyć zamówienie, musisz powiązać kartę zamówienia lunchu ze swoim kontem.",
    }    
  }
};
</script>


<style>
.oneday{
  background-color: rgba(233, 232, 248, 0.5);
  width: 354px;
  min-height: 80px;
  margin: 10px 5px;
  border-left: 4px solid;
  padding: 1px 5px;
  line-height: 1.2; 
}
.oneday p{
    font-size: 0.8rem; 
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/Lunch.vue